if (!customElements.get('complementary-bundle')) {
  customElements.define(
    'complementary-bundle',
    class ComplementaryBundle extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
        this.totalEl = this.querySelector('[data-bundle-total]');
        this.errorEl = this.querySelector('[data-bundle-error]');
        const mainData = this.querySelector('[data-bundle-main]');
        const main = mainData ? JSON.parse(mainData.textContent) : { prices: {} };
        this.mainPrices = main.prices;
        this.initialMainId = String(main.initialId);

        this.addEventListener('change', (event) => {
          const item = event.target.closest('[data-bundle-item]');
          if (item) this.updateItemPrice(item);
          this.updateTotal();
        });
        // The main variant picker lives outside this element, so listen on the page.
        document.addEventListener('change', () => setTimeout(() => this.updateTotal(), 200));

        // "Add to cart" (product-form.js) asks for the ticked items and adds them before the main product.
        window.getComplementaryBundleItems = () => this.selectedItems().map((v) => ({ id: v.id, quantity: 1 }));
        // The dynamic checkout button only knows about the main product, so while this bundle is shown a
        // replacement "Buy it now" button (from buy-buttons.liquid) adds everything and goes to checkout.
        this.onBuyNowClick = (event) => {
          if (event.target.closest('[data-bundle-buy-now]')) this.buyNow();
        };
        document.addEventListener('click', this.onBuyNowClick);
        this.updateTotal();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onBuyNowClick);
      }

      get mainVariantId() {
        const input = document.querySelector('product-form form input[name="id"]');
        return input && input.value ? String(input.value) : this.initialMainId;
      }

      get mainQuantity() {
        const input = document.querySelector('product-info input[name="quantity"]');
        return Math.max(1, parseInt(input && input.value, 10) || 1);
      }

      selectedItems() {
        return [...this.querySelectorAll('[data-bundle-item]')]
          .filter((item) => item.querySelector('[data-bundle-check]').checked)
          .map((item) => this.variantOf(item));
      }

      variantOf(item) {
        const control = item.querySelector('[data-bundle-variant]');
        const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
        return { id: Number(option.value), price: Number(option.dataset.price) };
      }

      updateItemPrice(item) {
        item.querySelector('[data-bundle-price]').textContent = this.formatMoney(this.variantOf(item).price);
      }

      updateTotal() {
        const mainTotal = (this.mainPrices[this.mainVariantId] || 0) * this.mainQuantity;
        const total = this.selectedItems().reduce((sum, v) => sum + v.price, mainTotal);
        this.totalEl.textContent = this.formatMoney(total);
      }

      async buyNow() {
        this.errorEl.hidden = true;
        const items = [{ id: Number(this.mainVariantId), quantity: this.mainQuantity }].concat(
          this.selectedItems().map((v) => ({ id: v.id, quantity: 1 }))
        );
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Could not add items to cart.');
          window.location.href = window.Shopify.routes.root + 'checkout';
        } catch (error) {
          this.errorEl.textContent = error.message;
          this.errorEl.hidden = false;
        }
      }

      formatMoney(cents) {
        const withDelimiters = (value, decimals) => {
          const [whole, fraction] = (value / 100).toFixed(decimals).split('.');
          return whole.replace(/(\d)(?=(\d\d)+\d$)/g, '$1,') + (fraction ? '.' + fraction : '');
        };
        return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, format) =>
          format === 'amount_no_decimals' ? withDelimiters(cents, 0) : withDelimiters(cents, 2)
        );
      }
    }
  );
}
